import { initialState, loadedState, loadingState, emptyState } from '../../initialState';

import {
    RACING_LOADING,
    RACING_LOADING_SUCCESS,
    RACING_LOADING_ERROR,
    RACING_LOADED_EMPTY,
} from '../actions/types';

/**
 * Loading racing widget reducer
 * NB: If you add any actions here you must also add them to racingReducer.js
 * @param {Object} state the current state
 * @param {Object} action the action
 * @returns {Object} new state
 */
export default function loadingReducer(state = initialState, action) {
    switch (action.type) {
        case RACING_LOADING: {
            return {
                ...state,
                ...loadingState,
            };
        }
        case RACING_LOADING_SUCCESS: {
            return {
                ...state,
                ...loadedState,
            };
        }
        case RACING_LOADING_ERROR: {
            return initialState;
        }
        case RACING_LOADED_EMPTY: {
            return emptyState;
        }
        default:
            return state;
    }
}
